export default {
  getCollapsed: state => state.menuState.collapsed
};
